const al = {
    share_title: 'Vodafone Share',
    share_internet_subtitle: 'Dërgo Internet',
    share_coins_subtitle: 'Dërgo Vcoin',
    share_balance_subtitle: 'Dërgo Balancë',
    share_minutes_subtitle: 'Dërgo Minuta',
    share_label_choose_transfer: 'Zgjidh Transfertën',
    share_limit: '%1$s/%2$s %3$s',
    share_transfer_button: 'Transfero',
    share_phone_number: 'Numri i telefonit',
    share_label_problem: 'Ups, ndodhi një problem!',
    share_label_success: 'Transferta u krye me sukses',
    share_button_go_back: 'Kthehu',
    share_button_close: 'Mbyll',
    share_button_confirm: 'Konfirmo',
    share_pay_with: 'Paguaj me:',
    share_confirm_message: 'Ti po transferon %1$s drejt numrit %3$s',
    share_wrong_phone_format: 'Numër i gabuar. Numri duhet të jetë: 3556xxxxxxxx',
    share_payment_type_bill: 'Faturë',
    share_payment_type_balance: 'Balancë',
    share_minutes_label: 'Minutat që po transferoni janë të vlefshme deri në %1$s',
    share_balance_label: 'Balanca që po transferoni është e vlefshme deri në %1$s',
    share_internet_label: 'Interneti që po transferoni është i vlefshëm deri në %1$s',
    share_vcoins_label: 'Vcoins që po transferoni janë të vlefshme deri në %1$s',
    share_reached_daily_limit: 'Ju keni arritur limitin ditor',
    share_reached_monthly_limit: 'Ju keni arritur limitin mujor',
    monthly_limit: 'Limiti mujor',
    daily_limit: 'Limiti ditor',
    receiving_monthly_limit: 'Limiti i marrjes',
    transfering_monthly_limit: 'Limiti i transferimit',
    number_of_transfer: 'Numri i transfertave',
    share_reached_number_of_transfer: 'Ju keni arritur limitin e transfertave',
    share_reached_transfering_monthly_limit: 'Ju keni arritur limitin e transferimit',
    share_reached_receiving_monthly_limit: 'Ju keni arritur limitin e marrjes',
    share_no_transfer_options: 'Ju nuk keni asnjë opsion transferte për momentin',
}

export default al
